/**
 * satv.media module
 * @author Mark Cremer <mark@firstcoders.co.uk>
 */

angular.module('satv.media', [
    'satv.player',
    'satv.assetlist'
], ['$interpolateProvider', function ($interpolateProvider) {
    $interpolateProvider.startSymbol('[[');
    $interpolateProvider.endSymbol(']]');
}])
    .constant('config', app_config);



// WEBPACK FOOTER //
// ./vendor/sonyatv/mediaclientbundle/Resources/js/angular/module.js